import { CrudAlertComponent } from './../../shared/crud-alert/crud-alert.component';
import { CrudAlertService } from './../../services/crud-alert.service';
import { AddVideoComponent } from './../../shared/add-video/add-video.component';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { catchError, tap, first } from 'rxjs/operators';
import { AddAttachComponent } from 'src/app/shared/add-attach/add-attach.component';
import { ApiService } from 'src/app/services/api.service';
import { Poi } from 'src/app/core/poi/poi.model';
import { SuccessRequestComponent } from 'src/app/shared/success-request/success-request.component';
import { FailRequestComponent } from 'src/app/shared/fail-request/fail-request.component';
import { User } from 'src/app/core/users/users.model';
import { PoiActionService } from 'src/app/core/poi/poi.action';
import { Attachments } from 'src/app/core/attachments/attachments.model';
import { AddAvatarComponent } from 'src/app/shared/add-avatar/add-avatar.component';

@Component({
  selector: 'app-new-poi',
  templateUrl: './new-poi.component.html',
  styleUrls: ['./new-poi.component.scss']
})
export class NewPoiComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('map', {static: false}) mapElement: ElementRef;
  @ViewChild('avatar') avatar: any;
  @ViewChild('titleAudio') title_audio: any;
  @ViewChild('themesSelection') themes_selection: any;
  @ViewChild('geoposSelection') geopos_selection: any;
  @ViewChild('picSelection') pic_selection: any;
  @ViewChild('audioSelection') audio_selection: any;
  @ViewChild('docSelection') doc_selection: any;
  @ViewChild('videoSelection') video_selection: any;

  poi_current: Poi = {
    id: null,
    poi_name: {
      it: '',
      sl: '',
      en: '',
    },
    short_descr: {
      it: '',
      sl: '',
      en: '',
    },
    description: {
      it: '',
      sl: '',
      en: '',
    },
    trivia: {
      it: '',
      sl: '',
      en: '',
    },
    address: '',
    coords: {
      lat: null,
      lon: null
    },
    attachments: [],
    themes: [],
    geopos: [],
    views: 0,
    approved: false,
    user_id: null
  };

  @select(['theme', 'list'])
  themes_list$: Observable<any>;
  themes_list = [];
  @select(['geopos', 'list'])
  geopos_list$: Observable<any>;
  geopos_list = [];

  @select(['logged', 'logged'])
  user_logged$: Observable<any>;
  user_logged: User;

  current_lang = 'it';
  att_pics: string[] = [];
  att_video: string[] = [];
  att_docs: string[] = [];

  actual_att_selection = [];
  subscriptions: Subscription[] = [];
  loading = false;

  geopos_center = {
    'Cimbri dell\'Altopiano dei Sette Comuni': {lat: 45.891109, lon: 11.547864},
    'Friulani in Veneto': {lat: 45.77391749995606, lon: 12.937330012651866},
    'Italiani in Slovenia': {lat: 45.50906685999279, lon: 13.780505952515352 },
    'Ladini del Comelico': {lat: 46.602049522923586, lon: 12.550061946245616},
    'Sloveni in Italia': {lat: 45.956334177758094, lon: 13.467896260697547 },
    'Friulani in Friuli Venezia Giulia': {lat: 45.956334177758094, lon: 13.467896260697547 }
  };

  generic_center = {
    lat: Object.keys(this.geopos_center).map((elem) =>
      this.geopos_center[elem].lat).reduce((a, b) => a + b, 0) / Object.keys(this.geopos_center).length,
    lon: Object.keys(this.geopos_center).map((elem) =>
      this.geopos_center[elem].lon).reduce((a, b) => a + b, 0) / Object.keys(this.geopos_center).length,
  };

  map: google.maps.Map;
  infoWindow: google.maps.InfoWindow;

  clickMapText = '';

  constructor(private titleService: Title,
              private route: Router,
              private apiservice: ApiService,
              private translate: TranslateService,
              public dialog: MatDialog,
              private poiAction: PoiActionService,
              private crudAlertService: CrudAlertService) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.translate.use(this.translate.currentLang);
    } else {
      this.translate.use('it');
    }
    this.translate.get('breadcrumb.new_poi').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.changeLangFunction();
    });
  }

  ngOnInit(): void {
    this.user_logged$.pipe(
      first(),
      tap((user) => {
        this.user_logged = user;
        this.poi_current.user_id = this.user_logged.id;
        if (user.auth_user === 'admin' || user.auth_user === 'editor') {
          this.poi_current.geopos = [...this.user_logged.geopos];
        }
      })
    ).subscribe();

    this.subscriptions.push(
      this.themes_list$.subscribe(list => {
        this.themes_list = [...list];
      }),
      this.geopos_list$.subscribe(list => {
        this.geopos_list = [...list];
      }),
    );
    this.translate.get('new_poi.sections.click_map').pipe(
      first(),
      tap((res: string) => {
        this.clickMapText = res;
      }),
    ).subscribe();
  }

  ngAfterViewInit(): void {
    this.mapInitializer();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  changeLangFunction(): void {
    this.current_lang = this.translate.currentLang;
    this.translate.get('new_poi.sections.click_map').pipe(
      first(),
      tap((res: string) => {
        this.clickMapText = res;
        if (!!this.mapElement) {
          this.mapInitializer();
        }
      }),
    ).subscribe();
  }

  mapInitializer(): void {
    let centerLat = this.generic_center.lat;
    let centerLon = this.generic_center.lon;
    if (this.poi_current.geopos.length > 0) {
      centerLat = this.geopos_center[this.poi_current.geopos[0].name.it].lat;
      centerLon = this.geopos_center[this.poi_current.geopos[0].name.it].lon;
    }
    const mapProperties = {
      center: new google.maps.LatLng(centerLat, centerLon),
      zoom: 11,
      restriction: {
        latLngBounds: {
          north: 47,
          south: 45,
          west: 10.9,
          east: 14.6
        },
        strictBounds: false,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);

    // Create the initial InfoWindow.
    this.infoWindow = new google.maps.InfoWindow({
      content: this.clickMapText,
      position: { lat: centerLat, lng: centerLon },
    });
    this.infoWindow.open(this.map);

    // Configure the click listener.
    this.map.addListener('click', (mapsMouseEvent) => {
      // Close the current InfoWindow.
      this.infoWindow.close();

      // Create a new InfoWindow.
      this.infoWindow = new google.maps.InfoWindow({
        position: mapsMouseEvent.latLng,
      });
      const lat = mapsMouseEvent.latLng.toJSON().lat;
      const lon = mapsMouseEvent.latLng.toJSON().lng;
      const contentString =
        '<div id="content">' +
        '<div id="siteNotice"></div>' +
        '<div id="bodyContent">' +
        '<p><b>Lat</b>: ' + lat.toString().slice(0, 7) + '</p>' +
        '<p><b>Lng</b>: ' + lon.toString().slice(0, 7) + '</p>' +
        '</div>' +
        '</div>';
      this.infoWindow.setContent(contentString);
      this.poi_current.coords = {lat, lon};
      this.infoWindow.open(this.map);
    });
  }

  updateCoords() {
    // Close the current InfoWindow.
    this.infoWindow.close();

    if (!!this.poi_current.coords?.lat && !!this.poi_current.coords?.lon) {
      const lat = this.poi_current.coords?.lat;
      const lon = this.poi_current.coords?.lon;
      // Create a new InfoWindow.
      this.infoWindow = new google.maps.InfoWindow({
        position: {
          lat,
          lng: lon
        },
      });
      const contentString =
        '<div id="content">' +
        '<div id="siteNotice"></div>' +
        '<div id="bodyContent">' +
        '<p><b>Lat</b>: ' + lat.toString().slice(0, 7) + '</p>' +
        '<p><b>Lng</b>: ' + lon.toString().slice(0, 7) + '</p>' +
        '</div>' +
        '</div>';
      this.infoWindow.setContent(contentString);
      this.poi_current.coords = {lat, lon};
      this.infoWindow.open(this.map);
    }
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }

  themesSelectionFunction() {
    this.poi_current.themes = this.themes_selection.selectedOptions.selected.map((opt) => opt._value);
  }

  geoposSelectionFunction() {
    this.poi_current.geopos = this.geopos_selection.selectedOptions.selected.map((opt) => opt._value);
    this.poi_current.coords = {lat: null, lon: null};
    this.mapInitializer();
  }

  checkGeopos(geopos) {
    if (this.poi_current.geopos.length > 0) {
      return geopos.id === this.poi_current.geopos[0].id;
    } else {
      return false;
    }
  }

  addAtt() {
    const dialogRef = this.dialog.open(AddAttachComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.poi_current.attachments.push(result);
      }
    });
  }

  addVid() {
    const dialogRef = this.dialog.open(AddVideoComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.poi_current.attachments.push(result);
      }
    });
  }

  addAva() {
    const dialogRef = this.dialog.open(AddAvatarComponent, {
      width: '450px',
      data: {
        current_lang: this.current_lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const avatarIdx = this.poi_current.attachments.findIndex(({avatar}) => avatar);
        if (avatarIdx < 0) {
          this.poi_current.attachments.push(result);
        } else {
          this.poi_current.attachments.splice(avatarIdx, 1, result);
        }
      }
    });
  }

  remAtt() {
    for (const att of this.actual_att_selection) {
      let index_of_att = this.poi_current.attachments.indexOf(att);
      if (index_of_att > -1) {
        this.poi_current.attachments.splice(index_of_att, 1);
      }
    }
  }

  attachmentSelectionFunction() {
    const values_selected = [];
    if (this.pic_selection !== undefined) {
      for (const opt of this.pic_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.audio_selection !== undefined) {
      for (const opt of this.audio_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.doc_selection !== undefined) {
      for (const opt of this.doc_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.video_selection !== undefined) {
      for (const opt of this.video_selection.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }
    if (this.avatar !== undefined) {
      for (const opt of this.avatar.selectedOptions.selected) {
        values_selected.push(opt._value);
      }
    }

    this.actual_att_selection = [...values_selected];
  }

  checkDict(array_of_dict, elem_id) {
    let list_of_ids = array_of_dict.map((value) => value.id);
    return list_of_ids.includes(elem_id);
  }

  checkAttachments(att_list: Attachments[], att_type: string) {
    for (const att of att_list) {
      if ((att.file_type === att_type && att_type !== 'picture') ||
        (att.file_type === att_type && att_type === 'picture' && !att.avatar) ||
        (att_type === 'avatar' && att.avatar)) {
        return true;
      }
    }
    return false;
  }

  singleTypeAttachments(att_list: Attachments[], att_type: string) {
    let single_type_list = [];
    for (const att of att_list) {
      if ((att.file_type === att_type && att_type !== 'picture') ||
        (att.file_type === att_type && att_type === 'picture' && !att.avatar) ||
        (att_type === 'avatar' && att.avatar)) {
        single_type_list.push(att);
      }
    }
    return single_type_list;
  }

  savePoi() {
    this.loading = true;
    const poiValidityErrors: string[] = this.crudAlertService.checkPoiValidity(this.poi_current);
    if (poiValidityErrors === null) {
      this.apiservice.newPoi(this.poi_current).pipe(
        tap((x: any) => {
          if (x && !x.error) {
            this.poiAction.addOrUpdatePoi(x);
            this.loading = false;
            const dialogRef = this.dialog.open(SuccessRequestComponent, {
              width: '450px'
            });
            dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-poi'));
          }
        }),
        catchError(error => {
          this.loading = false;
          this.dialog.open(FailRequestComponent, {
            width: '450px'
          });
          return throwError(error);
        })
      ).subscribe();
    } else if (poiValidityErrors?.length > 0) {
      this.loading = false;
      this.dialog.open(CrudAlertComponent, {
        width: '450px',
        data: {
          alertFields: poiValidityErrors
        }
      });
    }
  }

  titleAudioDisabled() {
    return this.poi_current.attachments.some(({title_audio}) => title_audio === true);
  }

  titleAudioSelection() {
    const option_selected = this.title_audio.selectedOptions.selected[0]._value;
    const index = this.poi_current.attachments.indexOf(option_selected);
    this.poi_current.attachments[index].title_audio = true;
  }
}
